import { useMutation } from "@tanstack/react-query";
import { client } from "@/api/client";
import { handleError } from "@/api/error";

type ForgotPasswordPayload = {
  email: string;
};

export const useForgotPassword = () => {
  return useMutation({
    mutationFn: async (payload: ForgotPasswordPayload) => {
      const res = await client.v2["forgot-password"].$post({
        json: payload,
      });
      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
  });
};
